<template>
  <span>
    <span v-for="(part, partIndex) in parts"
          :key="partIndex"
          :class="{ 'est-search__hit': part.hit }">{{ part.text }}</span>
  </span>
</template>

<script>
  // Estesoft.App/clientapp/src/components/shared/HighlightedText.vue kopyası (Aşama 4.1).
  // Vega'da `.est-search__hit` için stil yok: vurgu işaretlemesi var, görünüm değişmez.
  import { highlightParts } from '../../utils/highlight'

  export default {
    name: 'HighlightedText',
    props: {
      text: {
        type: [String, Number],
        default: ''
      },
      term: {
        type: String,
        default: ''
      }
    },
    computed: {
      parts() {
        return highlightParts(this.text, this.term)
      }
    }
  }
</script>
